import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetById, Update } from 'adminApi/FoodTypeApi/FoodType';
import { validateForm } from "utils/validation";
import { FoodTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditFoodTypeForm from "./Components/EditFoodTypeForm";
import Fields from "../json/FoodTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

/**
 * EditFoodType — Smart container for editing an existing food type.
 * Fetches current data by ID and handles the update submission.
 */
const EditFoodType = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = Fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues } = useFormChange(
        initialValues,
        FoodTypeRules
    );

    // Fetch existing data by ID to pre-fill the form
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Form update handler
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Update({ id, data: formData });
        },
        (vals) => validateForm(vals, FoodTypeRules),
        () => navigate(-1),
        "Food Type updated successfully."
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner />}
            <EditFoodTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Food Categories"
            />
        </>
    );
};

export default EditFoodType;
